import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { CancelIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';
import Button from './Button.js';

var _excluded = ["as", "className", "data-testid", "size", "removable", "clickable", "color", "children", "avatar", "onRequestDelete", "onClick", "disabled"];
var Chip = function Chip(props, ref) {
  var _classnames, _children$0$type;
  var _props$as = props.as,
    As = _props$as === void 0 ? "".concat(props.clickable || props.onClick ? props.clickable === false ? 'div' : 'button' : 'div') : _props$as,
    className = props.className,
    dataTestId = props['data-testid'],
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size,
    removable = props.removable,
    clickable = props.clickable,
    _props$color = props.color,
    color = _props$color === void 0 ? 'default' : _props$color,
    children = props.children,
    avatar = props.avatar,
    onRequestDelete = props.onRequestDelete,
    onClick = props.onClick,
    disabled = props.disabled,
    otherProps = _objectWithoutProperties(props, _excluded);
  alertUserOfDeprecatedProps('Chip', otherProps, color);
  var finalClasses = classnames('C-Chip', (_classnames = {
    '--avatar': avatar,
    '--clickable': clickable === false ? false : clickable || onClick
  }, _defineProperty(_classnames, "--size-".concat(size), size), _defineProperty(_classnames, '--removable', removable || onRequestDelete), _defineProperty(_classnames, "--color-".concat(color), color), _classnames), className);
  var avatarChild;
  var textChild;
  if (Array.isArray(children) && ((_children$0$type = children[0].type) === null || _children$0$type === void 0 ? void 0 : _children$0$type.displayName) === 'Avatar') {
    avatarChild = children[0];
    textChild = children[1];
  } else {
    textChild = children;
  }
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses,
    "data-testid": dataTestId,
    onClick: clickable === false || disabled ? undefined : onClick,
    role: color === 'alert' || color === 'error' ? 'alert' : undefined
  }, otherProps, {
    ref: ref
  }), avatarChild, /*#__PURE__*/React.createElement("span", {
    className: "C-Chip__children"
  }, textChild), (removable || onRequestDelete) && /*#__PURE__*/React.createElement(Button, {
    "data-testid": dataTestId ? "".concat(dataTestId, "_removeButton") : null,
    disabled: disabled,
    iconOnly: true,
    size: size,
    "aria-label": "remove",
    onClick: onRequestDelete
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    size: "sm",
    icon: CancelIcon
  })));
};
Chip.displayName = 'Chip';
var Chip$1 = /*#__PURE__*/React.forwardRef(Chip);

export { Chip$1 as default };
